import { createTheme } from "@mui/material/styles";

const CustomTimePickerTheme = ({ palette }) =>
    createTheme({
        components: {
            MuiOutlinedInput: {
                styleOverrides: {
                    root: {
                        fontSize: "14px",
                        height: "36px",
                        "& legend": {
                            width: "fit-content"
                        },
                        "&:hover fieldset": {
                            borderColor: `${palette.inputBorder.main} !important`
                        },
                        "&.Mui-focused fieldset": {
                            borderColor: `${palette.primary.main} !important`
                        }
                    }
                }
            },
            MuiFormControl: {
                styleOverrides: {
                    root: {
                        width: "100%"
                    }
                }
            },
            MuiFormLabel: {
                styleOverrides: {
                    root: {
                        top: "2px !important"
                    }
                }
            },
            MuiPaper: {
                styleOverrides: {
                    root: {
                        width: "236px"
                    }
                }
            },
            MuiList: {
                styleOverrides: {
                    root: {
                        maxHeight: "200px",
                        overflowY: "auto"
                    }
                }
            },
            MuiMenuItem: {
                styleOverrides: {
                    root: {
                        display: "flex",
                        justifyContent: "flex-start",
                        height: "36px",
                        fontSize: "14px",
                        "&.Mui-selected": {
                            backgroundColor: palette.primary.light
                        }
                    }
                }
            },
            MuiInputLabel: {
                styleOverrides: {
                    root: {
                        fontSize: "14px",
                        "&.Mui-focused": {
                            color: palette.primary.main
                        }
                    }
                }
            },
            MuiIconButton: {
                styleOverrides: {
                    root: {
                        "&:hover": {
                            backgroundColor: "transparent !important"
                        }
                    }
                }
            }
        }
    });

export default CustomTimePickerTheme;
